<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            x="25"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="32"
              height="28"
              viewBox="0 0 32 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.0352 9.57444L27.8464 3.19045C27.5289 2.26097 26.9182 1.45242 26.101 0.879679C25.2838 0.306936 24.3018 -0.00086832 23.2944 1.83987e-06H8.7056C7.69822 -0.00086832 6.71618 0.306936 5.89902 0.879679C5.08185 1.45242 4.47112 2.26097 4.1536 3.19045L1.9648 9.57444C1.38276 9.81122 0.885697 10.21 0.536107 10.7207C0.186517 11.2313 -7.6944e-07 11.831 0 12.4444V20.2222C0 21.3702 0.6464 22.3627 1.6 22.9024V26.4444C1.6 26.857 1.76857 27.2527 2.06863 27.5444C2.36869 27.8361 2.77565 28 3.2 28H4.8C5.22435 28 5.63131 27.8361 5.93137 27.5444C6.23143 27.2527 6.4 26.857 6.4 26.4444V23.3333H25.6V26.4444C25.6 26.857 25.7686 27.2527 26.0686 27.5444C26.3687 27.8361 26.7757 28 27.2 28H28.8C29.2243 28 29.6313 27.8361 29.9314 27.5444C30.2314 27.2527 30.4 26.857 30.4 26.4444V22.9024C30.8854 22.6318 31.2889 22.2415 31.5698 21.771C31.8507 21.3005 31.9991 20.7663 32 20.2222V12.4444C32 11.831 31.8135 11.2313 31.4639 10.7207C31.1143 10.21 30.6172 9.81122 30.0352 9.57444ZM8.7056 3.11111H23.2928C23.9824 3.11111 24.5936 3.53733 24.8112 4.17511L26.5808 9.33333H5.4192L7.1872 4.17511C7.29336 3.86524 7.49715 3.59571 7.76968 3.40474C8.04221 3.21376 8.36966 3.11103 8.7056 3.11111V3.11111ZM5.6 18.6667C5.28472 18.6666 4.97255 18.6061 4.68131 18.4887C4.39008 18.3713 4.12547 18.1993 3.90261 17.9825C3.67975 17.7657 3.503 17.5083 3.38244 17.2251C3.26189 16.9418 3.19989 16.6383 3.2 16.3318C3.20011 16.0253 3.26231 15.7218 3.38306 15.4386C3.5038 15.1555 3.68073 14.8982 3.90374 14.6815C4.12675 14.4649 4.39147 14.293 4.68279 14.1758C4.97411 14.0586 5.28632 13.9983 5.6016 13.9984C6.23833 13.9986 6.8489 14.2448 7.29899 14.6826C7.74908 15.1205 8.00181 15.7143 8.0016 16.3333C8.00139 16.9524 7.74824 17.546 7.29786 17.9836C6.84747 18.4212 6.23673 18.6669 5.6 18.6667V18.6667ZM26.4 18.6667C26.0847 18.6666 25.7726 18.6061 25.4813 18.4887C25.1901 18.3713 24.9255 18.1993 24.7026 17.9825C24.4798 17.7657 24.303 17.5083 24.1824 17.2251C24.0619 16.9418 23.9999 16.6383 24 16.3318C24.0001 16.0253 24.0623 15.7218 24.1831 15.4386C24.3038 15.1555 24.4807 14.8982 24.7037 14.6815C24.9268 14.4649 25.1915 14.293 25.4828 14.1758C25.7741 14.0586 26.0863 13.9983 26.4016 13.9984C27.0383 13.9986 27.6489 14.2448 28.099 14.6826C28.5491 15.1205 28.8018 15.7143 28.8016 16.3333C28.8014 16.9524 28.5482 17.546 28.0979 17.9836C27.6475 18.4212 27.0367 18.6669 26.4 18.6667V18.6667Z"
                fill="url(#paint0_linear_587_17978)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_587_17978"
                  x1="16"
                  y1="0"
                  x2="16"
                  y2="28"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#9FC2FF" />
                  <stop
                    offset="0.890625"
                    stop-color="#266EEC"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>รถขับต่ำกว่า 90 km/hr เลนขวา</strong>
            <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ Speed90 }} </b>
              <span style="font-size: 20px;">คัน</span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            x="25"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="32"
              height="28"
              viewBox="0 0 32 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.0352 9.57444L27.8464 3.19045C27.5289 2.26097 26.9182 1.45242 26.101 0.879679C25.2838 0.306936 24.3018 -0.00086832 23.2944 1.83987e-06H8.7056C7.69822 -0.00086832 6.71618 0.306936 5.89902 0.879679C5.08185 1.45242 4.47112 2.26097 4.1536 3.19045L1.9648 9.57444C1.38276 9.81122 0.885697 10.21 0.536107 10.7207C0.186517 11.2313 -7.6944e-07 11.831 0 12.4444V20.2222C0 21.3702 0.6464 22.3627 1.6 22.9024V26.4444C1.6 26.857 1.76857 27.2527 2.06863 27.5444C2.36869 27.8361 2.77565 28 3.2 28H4.8C5.22435 28 5.63131 27.8361 5.93137 27.5444C6.23143 27.2527 6.4 26.857 6.4 26.4444V23.3333H25.6V26.4444C25.6 26.857 25.7686 27.2527 26.0686 27.5444C26.3687 27.8361 26.7757 28 27.2 28H28.8C29.2243 28 29.6313 27.8361 29.9314 27.5444C30.2314 27.2527 30.4 26.857 30.4 26.4444V22.9024C30.8854 22.6318 31.2889 22.2415 31.5698 21.771C31.8507 21.3005 31.9991 20.7663 32 20.2222V12.4444C32 11.831 31.8135 11.2313 31.4639 10.7207C31.1143 10.21 30.6172 9.81122 30.0352 9.57444ZM8.7056 3.11111H23.2928C23.9824 3.11111 24.5936 3.53733 24.8112 4.17511L26.5808 9.33333H5.4192L7.1872 4.17511C7.29336 3.86524 7.49715 3.59571 7.76968 3.40474C8.04221 3.21376 8.36966 3.11103 8.7056 3.11111V3.11111ZM5.6 18.6667C5.28472 18.6666 4.97255 18.6061 4.68131 18.4887C4.39008 18.3713 4.12547 18.1993 3.90261 17.9825C3.67975 17.7657 3.503 17.5083 3.38244 17.2251C3.26189 16.9418 3.19989 16.6383 3.2 16.3318C3.20011 16.0253 3.26231 15.7218 3.38306 15.4386C3.5038 15.1555 3.68073 14.8982 3.90374 14.6815C4.12675 14.4649 4.39147 14.293 4.68279 14.1758C4.97411 14.0586 5.28632 13.9983 5.6016 13.9984C6.23833 13.9986 6.8489 14.2448 7.29899 14.6826C7.74908 15.1205 8.00181 15.7143 8.0016 16.3333C8.00139 16.9524 7.74824 17.546 7.29786 17.9836C6.84747 18.4212 6.23673 18.6669 5.6 18.6667V18.6667ZM26.4 18.6667C26.0847 18.6666 25.7726 18.6061 25.4813 18.4887C25.1901 18.3713 24.9255 18.1993 24.7026 17.9825C24.4798 17.7657 24.303 17.5083 24.1824 17.2251C24.0619 16.9418 23.9999 16.6383 24 16.3318C24.0001 16.0253 24.0623 15.7218 24.1831 15.4386C24.3038 15.1555 24.4807 14.8982 24.7037 14.6815C24.9268 14.4649 25.1915 14.293 25.4828 14.1758C25.7741 14.0586 26.0863 13.9983 26.4016 13.9984C27.0383 13.9986 27.6489 14.2448 28.099 14.6826C28.5491 15.1205 28.8018 15.7143 28.8016 16.3333C28.8014 16.9524 28.5482 17.546 28.0979 17.9836C27.6475 18.4212 27.0367 18.6669 26.4 18.6667V18.6667Z"
                fill="url(#paint0_linear_587_17988)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_587_17988"
                  x1="16"
                  y1="0"
                  x2="16"
                  y2="28"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#A2FFC7" />
                  <stop
                    offset="0.890625"
                    stop-color="#10BF56"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            x="65"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>รถขับมากกว่า 120 km/hr เลนขวา</strong>
            <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b>{{ Speed120 }}</b>
              <span style="font-size: 20px; color: #fff;"> คัน </span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/markeranalytic120\iconA120\accident.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>รถจอด / อุบัติเหตุ</strong>
            <!-- <em>word wrap</em> -->
            </div>
            <b-card-header style="margin-top: 10px; text-align: right;">
              <b-button
                id="toggle-btn"
                v-b-modal="'modalCarStop'"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                style="font-size: 14px;"
                title="Click to show more"
              >
                <span
                  class="align-middle"
                  style="color: #11DF00;"
                >
                  ดูเพิ่มเติม
                  <feather-icon
                    icon="ChevronsRightIcon"
                    size="14"
                  />
                </span>
              </b-button>
            </b-card-header>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="200"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ CarStop }} </b>
              <span style="font-size: 20px;">คัน</span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="6"
        xs="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/markeranalytic120\iconA120\reverse.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>รถย้อนศร</strong>
            <!-- <em>word wrap</em> -->
            </div>
            <b-card-header style="margin-top: 10px; text-align: right;">
              <b-button
                id="toggle-btn"
                v-b-modal="'modalWrongWay'"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                style="font-size: 14px;"
                title="Click to show more"
              >
                <span
                  class="align-middle"
                  style="color: #11DF00;"
                >
                  ดูเพิ่มเติม
                  <feather-icon
                    icon="ChevronsRightIcon"
                    size="14"
                  />
                </span>
              </b-button>
            </b-card-header>
          </foreignObject>
          <foreignObject
            x="30"
            y="65"
            width="200"
            height="150"
            color="#ffffff"
            font-size="40"
          >
            <div>
              <b> {{ WrongWay }} </b>
              <span style="font-size: 20px;">คัน</span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <ModalWrongWay />
    <ModalCarStop />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCardHeader, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import ModalWrongWay from '@/views/StatisModal/ModalWrongWay.vue'
import ModalCarStop from '@/views/StatisModal/ModalCarStop.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCardHeader,
    BButton,
    ModalWrongWay,
    ModalCarStop,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      Speed120: '',
      Speed90: '',
      CarStop: '',
      WrongWay: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getStaticAIDetail()
    this.interval = setInterval(() => {
      this.getStaticAIDetail()
    }, 300000)
  },
  methods: {
    getStaticAIDetail() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCheckTypeAITotal-G', { wid: this.$route.query.wid })
          .then(response => {
            this.Speed120 = response.data[2][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.Speed90 = response.data[1][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.CarStop = response.data[0][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.WrongWay = response.data[5][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCheckTypeAITotal', { wid: this.$route.query.wid })
          .then(response => {
            this.Speed120 = response.data[2][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.Speed90 = response.data[1][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.CarStop = response.data[0][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            this.WrongWay = response.data[5][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style scoped>
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  </style>
